import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { ContentstackPartner } from './types/PartnerPage.types';

export const PARTNER_CONTENT_API_PATH = `${PUBLIC_API_BASE_PATH}partner-content`;

// Without a timeout fetchJSONWithTimeout skips the abort entirely. This route
// runs on our own pods, whose Contentstack call is itself bounded at 2000ms, so
// 5000ms leaves room for a healthy round trip while stopping the browser
// holding a connection open against a saturated pod.
const CLIENT_TIMEOUT_MS = 5000;

export const fetchPartnerContentClient = async (
  shortcode: string,
  { preview = false }: { preview?: boolean } = {},
): Promise<ContentstackPartner | null> => {
  const response = await fetchJSONWithTimeout(
    `${PARTNER_CONTENT_API_PATH}/${encodeURIComponent(shortcode)}${preview ? '?preview=true' : ''}`,
    { timeout: CLIENT_TIMEOUT_MS },
  );

  if (!response.ok) {
    return null;
  }

  return response.json();
};
